define.alias("checkout/components/seamless-checkout-table/charges", "settings/components/seamless-checkout-table/charges");